module.exports = __webpack_public_path__ + "6ce32c6180e205403f14ecd55d6aebd2.fbx";